// eslint-disable-next-line jira/restricted/react
import React, { type ComponentType, PureComponent } from 'react';
import { Container, MisconfiguredMessageContainer } from './styled';

export type Props = {
	isRunAsUserMisconfigured: boolean;
	hasRules: boolean;
	hasGlobalError: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	HeaderComponent: ComponentType<any>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	RuleListComponent: ComponentType<any>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	EmptyViewComponent: ComponentType<any>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	AddRuleComponent: ComponentType<any>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	PageErrorComponent: ComponentType<any>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	MisconfiguredMessageComponent: ComponentType<any>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	RuleLimitMessageComponent: ComponentType<any>;
};

// eslint-disable-next-line jira/react/no-class-components
export default class SummaryPage extends PureComponent<Props> {
	renderBody() {
		const {
			hasRules,
			hasGlobalError,
			isRunAsUserMisconfigured,
			RuleListComponent,
			EmptyViewComponent,
			PageErrorComponent,
			MisconfiguredMessageComponent,
			RuleLimitMessageComponent,
		} = this.props;
		if (hasGlobalError) {
			return <PageErrorComponent />;
		}
		if (hasRules) {
			return (
				<>
					{isRunAsUserMisconfigured && (
						<MisconfiguredMessageContainer>
							<MisconfiguredMessageComponent />
						</MisconfiguredMessageContainer>
					)}
					<RuleLimitMessageComponent />
					<RuleListComponent />
				</>
			);
		}
		return <EmptyViewComponent />;
	}

	render() {
		const { HeaderComponent, AddRuleComponent, hasRules, hasGlobalError } = this.props;
		return (
			<Container>
				<AddRuleComponent />
				<HeaderComponent hasRules={hasRules} showActions={hasRules && !hasGlobalError} />
				{this.renderBody()}
			</Container>
		);
	}
}
